import React from 'react'
import Menu from '../component/Menu';
import Headercareer from '../component/Headercareer'
import CareerDes from '../component/CareerDes'
import WeServeCareer from '../component/WeServeCareer'
import { LifeAtPs } from '../component/LifeAtPs';
// import Careerbody from '../component/Careerbody'
// import Careerjob from '../component/Careerjob'
import { Helmet } from 'react-helmet';
// import JobOpeningsSection from '../component/JobOpeningsSection';
import Testimonial from '../component/Testimonial';
import YourCareer from '../component/YourCareer';
import FooterNew from '../component/FooterNew';
// import TestTestimonial1 from '../component/TestTestimonial1';

  
const careerdata = {
  "eyebrow": "Take The Next Step",
  "heading": "In Yo<span class='anima-underline'>ur Career</span>",
  "description": "Explore opportunities to solve meaningful business challenges, work with talented teams, and grow your career at Preferred Square.",
  "cta": {
    "label": "View open positions",
    "href": "https://preferred-square.zohorecruit.in/"
  },
  "theme": {
    "bgFrom": "#050b16",
    "bgTo": "#0a1c33",
    "textColor": "#ffffff",
    "dividerFrom": "#2dd4bf",
    "dividerTo": "#ec4899",
    "buttonFrom": "#0d9488",
    "buttonTo": "#14b8a6",
    "buttonText": "#ffffff"
  }
}



const Career = ({setBlank}) => {
  const paragraph="We believe in creating an environment where ambitious professionals have the opportunity to create meaningful impact and work alongside industry experts on transformative and innovative projects. As a Great Place to Work® Certified (Apr 2026 to Apr 2027) organization, we are committed to fostering a culture of collaboration, continuous learning, and professional growth."




  return (
    <>  
    <Helmet>
      <title>Career</title>
      <meta property="og:title" content="Career" />
      <meta property="og:description" content="Career"/>
    </Helmet>
        <Menu setBlank={setBlank} />
        <Headercareer />   
        <CareerDes paragraph={paragraph} />
        <WeServeCareer />
        <LifeAtPs />
        <Testimonial />
        {/* <TestTestimonial1 /> */}
        {/* <JobOpeningsSection setBlank={setBlank} /> */}
        {/* <Careerbody /> */}
        {/* <Careerjob /> */}
        <YourCareer setBlank={setBlank} data={careerdata} />
        <FooterNew setBlank={setBlank} />
    </>
      
  )
}

export default Career
